import { useContext } from 'react';
import { useStore } from 'zustand';
import { WorkspaceInfoContext } from '../context';
import { WorkspaceInfoStore } from '../interfaces';

export const useWorkspaceInfoContext = <T>(
  selector: (state: WorkspaceInfoStore) => T,
) => {
  const context = useContext(WorkspaceInfoContext);

  if (!context)
    throw new Error(
      'useWorkspaceInfoContext must be used inside WorkspaceInfoContextProvider',
    );

  return useStore(context, selector);
};
